import LongCellPopUp from '../components/LongCellPopUp'
import { dateFormat, dateTimeFormat } from '../utils/formatter'


export const resourceLicensesCols = [
  {
    accessorKey: 'CREDENTIAL_DESCRIPTION',
    header: 'Credential',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'QUALIFICATIONSOURCE',
    header: 'Source',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'ESSENTIAL',
    header: 'Essential',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DREND',
    header: 'Expiration Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'VALIDATED',
    header: 'Validated',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VIVERIFICATIONDATE',
    header: 'Validation Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'DRBEGIN',
    header: 'Date Received',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'CREDENTIALNUMBER',
    header: 'Credential Number',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  }
]

export const resourceEducationCols = [
  {
    accessorKey: 'EDUCATION',
    header: 'Education',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'ESSENTIAL',
    header: 'Essential',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'SPECIALIZATION',
    header: 'Specialization',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'INSTITUTION',
    header: 'Institution',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'COMPLETION_DATE',
    header: 'Completion Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'In_process',
    header: 'In Process',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VALIDATED',
    header: 'Validated',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VIVERIFICATIONDATE',
    header: 'Validation Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]

export const resourceEmploymentHistoryCols = [
  {
    accessorKey: 'JOBTITLE',
    header: 'Job Title',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EMPLOYERNAME',
    header: 'Employer Name',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'BDYEAR',
    header: 'Begin Year',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'EDYEAR',
    header: 'End Year',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'REASONFORLEAVING',
    header: 'Reason for Leaving',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EAMUNICIPALITY',
    header: 'City',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EASTATEPROVINCE',
    header: 'State',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'PERMISSION_TO_CONTACT',
    header: 'Permission to Contact',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EMPLOYERCONTACTNAME',
    header: 'Contact Name',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'ECPSUBSCRIBERNUMBER',
    header: 'Contact Number',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'EMPLOYERCONTACTEMAIL',
    header: 'Contact Email',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'VALIDATED',
    header: 'Validated',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VIVERIFICATIONDATE',
    header: 'Validation Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]

export const resourcePerformanceHistoryCols = [
  {
    accessorKey: 'WORK_ASSIGNMENT',
    header: 'Work Assignment',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'POSITION',
    header: 'Position',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'APPRAISAL',
    header: 'Appraisal',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'APPRAISALCOMPLETIONDATE',
    header: 'Completed Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'APBEGIN',
    header: 'Period Begin',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'APEND',
    header: 'Period End',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'DOCUMENTOWNERSNAPSHOT',
    header: 'Document Type',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DOCUMENTOWNEREMPSNAPSHOT',
    header: 'Appraisal Owner',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'RATING',
    header: 'Overall Rating',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EMPLOYEE_ACKNOWLEDGED',
    header: 'Employee Acknowledged',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'EMPLOYEESIGNEDDATE',
    header: 'Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'SUPERVISOR_ACKNOWLEDGED',
    header: 'Supervisor Acknowledged',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'SUPERVISORSIGNEDDATE',
    header: 'Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]

export const resourceWorkAssignmentCols = [
  { accessorKey: 'position_name', header: 'Position Name', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'position', header: 'Position ID', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'workassignment', header: 'Work Assignment', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'fte', header: 'FTE', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'payrate', header: 'Pay Rate', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'organization', header: 'Organization', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'manager', header: 'Manager', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'Work_schedule', header: 'Work Schedule', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'Primary', header: 'Primary', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'active', header: 'Active', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'Pay_grade', header: 'Pay Grade', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'paystep', header: 'Pay Step', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'Indirect_manager', header: 'Dotted Line Manager', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'Step_grade_sched', header: 'Step and Grade Schedule', enableSorting: false, enableColumnFilter: true, size: 1 }
]

export const resourceWorkAssignmentAuditCols = [
  {
    accessorKey: 'EFFECTIVE_DT',
    header: 'Effective Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => <span>{cell.row.original.Effective_dt_link}</span>
  },
  { accessorKey: 'CORRECTION', header: 'Correction', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'ENTRY_TIME', header: 'Timestamp', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateTimeFormat(cell.getValue()) },
  { accessorKey: 'ACTOR', header: 'Actor', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'ACTION', header: 'Action', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'ACTION_TYPE', header: 'Action Type', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'REASON', header: 'Reason', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'COMMENT', header: 'Comment', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'SUBJECT', header: 'Subject', enableSorting: false, enableColumnFilter: true, size: 1 }
]

export const resourceWorkAssignmentAuditFieldsCols = [
  { accessorKey: 'FIELD_NAME', header: 'Field Name', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'OLD_VALUE', header: 'Old Value', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'NEW_VALUE', header: 'New Value', enableSorting: false, enableColumnFilter: false, size: 1 }
]

export const resourceCompensationCols = [
  {
    accessorKey: 'SHORTDESCRIPTION',
    header: 'Position',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'FTE',
    header: 'Full Time Equivalent',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'PAYRATE',
    header: 'Pay Rate',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'TOTAL_PAY_RATE',
    header: 'Pay Rate Total',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'PAYRATECURRENCY',
    header: 'Pay Rate Currency',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  }
]


export const resourceCommentsCols = [
  {
    accessorKey: 'COMMENT_TYPE',
    header: 'Comment Type',
    enableSorting: false,
    enableColumnFilter: true,
  },
  {
    accessorKey: 'COMMENT_VALUE',
    header: 'Comment',
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => <LongCellPopUp value={cell.getValue() || ''} />
  }
]

export const resourceCustomFieldsCols = [
  {
    accessorKey: 'FIELD_DISPLAY',
    header: 'Field',
    enableSorting: false,
    enableColumnFilter: true,
  },
  {
    accessorKey: 'FIELD_VALUE',
    header: 'Value',
    enableSorting: false,
    enableColumnFilter: false,
  }
]

export const resourceEmprelCoachingsCols = [
  { accessorKey: 'EMPREL_GROUP', header: 'Group', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'COACHING_TYPE', header: 'Type', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'MEETINGDATE', header: 'Meeting Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'MANAGER', header: 'Manager', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'HRCONTACT', header: 'HR Contact', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'FOLLOWUPSENT', header: 'Follow-Up Sent', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'FOLLOWUPDATE', header: 'Follow-Up Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'ERMSTARTTIME', header: 'ERM Start Time', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateTimeFormat(cell.getValue()) },
  { accessorKey: 'ERMENDTIME', header: 'ERM End Time', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateTimeFormat(cell.getValue()) },
  { accessorKey: 'ERMDURATION', header: 'ERM Duration', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'ERMREMINDER', header: 'ERM Reminder', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'CUSTOM_FIELDS_LINK', header: 'Custom Fields', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => <span>{cell.row.original.CUSTOM_FIELDS_LINK}</span> }
]

export const resourceEmprelCorrectiveCols = [
  { accessorKey: 'EMPREL_GROUP', header: 'Group', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'DISCIPLINE_TYPE', header: 'Type', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'MANAGER', header: 'Manager', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'HRCONTACT', header: 'HR Contact', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'STEP', header: 'Step', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'ISSUEDATE', header: 'Issue Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'INCIDENTDATE', header: 'Incident Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'SENTFORREVIEW', header: 'Sent for Review', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'REVIEWCOMPLETE', header: 'Review Complete', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'MEETINGDATE', header: 'Meeting Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'ENDDATE', header: 'End Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'FOLLOWUPSENT', header: 'Follow-Up Sent', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'FOLLOWUPDATE', header: 'Follow-Up Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'ERMSTARTTIME', header: 'ERM Start Time', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateTimeFormat(cell.getValue()) },
  { accessorKey: 'ERMENDTIME', header: 'ERM End Time', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateTimeFormat(cell.getValue()) },
  { accessorKey: 'ERMDURATION', header: 'ERM Duration', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'ERMREMINDER', header: 'ERM Reminder', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'ACKNOWLEDGESIGNATURE', header: 'Acknowledgement', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'DATEACKNOWLEDGED', header: 'Date Acknowledged', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'CUSTOM_FIELDS_LINK', header: 'Custom Fields', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => <span>{cell.row.original.CUSTOM_FIELDS_LINK}</span> }
]

export const resourceEmprelDisputesCols = [
  { accessorKey: 'EMPREL_GROUP', header: 'Group', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'DISPUTE_TYPE', header: 'Type', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'MANAGER', header: 'Manager', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'HRCONTACT', header: 'HR Contact', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'INCIDENTDATE', header: 'Incident Date', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'RECEIVED', header: 'Received', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'RESOLUTION', header: 'Resolution', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'RESOLVED', header: 'Resolved', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => dateFormat(cell.getValue()) },
  { accessorKey: 'EXTERNALREFERENCE', header: 'External Reference', enableSorting: false, enableColumnFilter: true, size: 1 },
  { accessorKey: 'CUSTOM_FIELDS_LINK', header: 'Custom Fields', enableSorting: false, enableColumnFilter: false, size: 1, Cell: ({ cell }) => <span>{cell.row.original.CUSTOM_FIELDS_LINK}</span> }
]

export const resourceUserFieldsCols = [
  { accessorKey: 'UFSFIELDNAME', header: 'Field Name', enableSorting: false, enableColumnFilter: false, size: 1 },
  { accessorKey: 'VALUE', header: 'Value', enableSorting: false, enableColumnFilter: false, size: 1 }
]
